import { render, staticRenderFns } from "./createSolidityDetectorTask.vue?vue&type=template&id=4027825c&scoped=true&"
import script from "./createSolidityDetectorTask.vue?vue&type=script&lang=js&"
export * from "./createSolidityDetectorTask.vue?vue&type=script&lang=js&"
import style0 from "./createSolidityDetectorTask.vue?vue&type=style&index=0&id=4027825c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027825c",
  null
  
)

export default component.exports